export class BoxClass {
  constructor(x, y, w, h,top, key, clicked) {
			this.xcord=x;
			this.ycord=y;
			this.width=w;
			this.height=h;
			this.id=key;
			this.top=top;
			this.clicked=clicked;
  }
}



// WEBPACK FOOTER //
// src/classes/BoxClass.js